<template>
    <a
        :href="href"
        class="inline-flex w-fit items-center justify-center gap-2 rounded-lg2 bg-primary px-5 py-3 text-base font-bold text-white shadow-xs shadow-primary-shade-ligth hover:bg-primary-shade"
    >
        {{ label }}
        <LandingPageIcon
            name="arrow-right"
            class="h-4 w-4"
            aria-hidden="true"
        />
    </a>
</template>

<script setup lang="ts">
    import LandingPageIcon from '@/Marketing/LandingPage/Component/LandingPageIcon.vue'

    interface FeaturePagePrimaryButtonProps {
        href: string
        label: string
    }

    defineProps<FeaturePagePrimaryButtonProps>()
</script>
